import { SVGProps } from '@components/Icon/types';

export const CommentsOnAchievements = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 2.5)">
      <path
        d="M14.1897 4.88788C14.5736 4.88788 14.8317 5.198 14.8318 5.51775V8.08377C14.8318 8.40352 14.5736 8.71363 14.1897 8.71363C13.806 8.7135 13.5486 8.40345 13.5486 8.08377V7.09194L11.2067 9.50595C10.9819 9.73752 10.6733 9.87171 10.3404 9.87171C10.0076 9.8716 9.69969 9.73742 9.47496 9.50595L8.07581 8.06382L6.27538 9.91732C6.15241 10.0456 5.98313 10.1129 5.81029 10.113C5.63531 10.113 5.46779 10.0445 5.34519 9.91827C5.10937 9.67538 5.10945 9.29192 5.34519 9.04899L7.20944 7.12804C7.43427 6.89649 7.7419 6.76228 8.07484 6.76228L8.19861 6.76893C8.48349 6.79781 8.74359 6.92549 8.94024 7.12804L10.3394 8.57018L12.6919 6.14761H11.6989C11.315 6.14761 11.0569 5.8375 11.0569 5.51775C11.0569 5.198 11.315 4.88788 11.6989 4.88788H14.1897Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8662 0C18.57 0 20 1.31154 20 2.95933V12.1147C20 13.7625 18.5695 15.0731 16.8662 15.0731H10.1141L5.55792 18.7355C5.15882 19.0561 4.64125 19.0643 4.22839 18.8723C3.81554 18.6802 3.49455 18.2816 3.49449 17.775V15.0731H3.13382C1.43002 15.0731 0 13.7625 0 12.1147V2.95933C0 1.31154 1.43002 0 3.13382 0H16.8662ZM3.13382 1.33954C2.12749 1.33954 1.36241 2.07953 1.36241 2.95933V12.1147C1.36241 12.9945 2.12749 13.7345 3.13382 13.7345H4.17521C4.35592 13.7345 4.52992 13.8047 4.65771 13.9302C4.7855 14.0558 4.85688 14.2267 4.85689 14.4043V17.5698L9.43918 13.8865C9.5608 13.7886 9.71318 13.7347 9.87043 13.7345H16.8662C17.8718 13.7345 18.6376 12.9945 18.6376 12.1147V7.63535C18.6272 7.56841 18.6272 7.49994 18.6376 7.433V2.95933C18.6376 2.07953 17.8725 1.33954 16.8662 1.33954H3.13382Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'comments-on-achievements';
